import { useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Button from '@/shared/components/Button/Button'
import TextComponent from '@/shared/components/TextComponent/TextComponent'
import DynamicForm from '@/shared/components/DynamicForm/DynamicForm'
import { EnvironmentVariable } from '@/lib/http/constants'

import styles from '@/features/auth/Forms/Login/Login.module.scss'

import { useLoginFormConfig } from '@/features/auth/Forms/Login/useLoginFormConfig'

function Login() {
  const { t } = useTranslation()

  const { formConfig, isLoggingIn } = useLoginFormConfig()

  /*
    core-api scales to zero (the infra module's default, dev included), and
    waking it took about 20 s, most of the wait after Log in. Knocking as soon
    as the form shows lets it start while the credentials are typed. Where it
    is already up this costs one small request. Nothing reads the answer. A
    plain CORS request, because no-cors trips the API's
    Cross-Origin-Resource-Policy and logs an error on every visit.
  */
  useEffect(() => {
    fetch(`${EnvironmentVariable.localEnvConfig.API_URL}/health/live`).catch(
      () => undefined
    )
  }, [])

  return (
    <div className={`${styles.loginContainer}`}>
      <h1 className={`title-bold-medium ${styles.loginHeader}`}>
        {t('AUTHORIZATION.LOGIN')}
      </h1>
      <DynamicForm condensed validationMode="onSubmit" {...formConfig} />
      <div className={`${styles.loginFormButtonContainer}`}>
        <div className={`${styles.loginHelpContainer}`}>
          {/* <div className={`${styles.accountHelpGroup}`}>
            <p
              className={`body-bold-medium ${styles.dontHaveAnAccountMessage}`}
            >
              {t('AUTHORIZATION.LOGIN.DONT_HAVE_ACCOUNT')}
            </p>
            <div className={`${styles.writeEmailMessageContainer}`}>
              <p className={`body-bold-medium ${styles.writeEmailMessage}`}>
                {t('AUTHORIZATION.LOGIN.WRITE_MESSAGE')}
              </p>
              <span className={`${styles.writeEmailAddress}`}>
                <TextComponent
                  text="pepek@pepek.com"
                  fontSize="body-bold-medium"
                  color="secondary"
                />
              </span>
            </div>
          </div> */}
          <NavLink
            className={`${styles.forgotPasswordLink}`}
            to="/reset-password"
          >
            <TextComponent
              text={t('AUTHORIZATION.LOGIN.FORGOT_PASSWORD')}
              fontSize="body-bold-medium"
              color="primary"
            />
          </NavLink>
        </div>
        <Button
          form="login-form"
          onClick={() => null}
          label={t('AUTHORIZATION.LOGIN')}
          variant="contained"
          color="primary"
          type="submit"
          // Also stops Enter from sending the same login again meanwhile.
          disabled={isLoggingIn}
          maxWidth
        />
      </div>
    </div>
  )
}

export default Login
